import { render, staticRenderFns } from "./logo.vue?vue&type=template&id=5409dafd&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5409dafd",
  null
  
)

export default component.exports